import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_ASSIGN_ORDER_TYPE:
      return { ...action.assignOrderType };
    default: return state;
  }
};
